export default __webpack_public_path__ + "static/media/ic-photo-white.6b9e7d2a.svg";